import { Loader2 } from 'lucide-react';
import { useIsRecalculating } from '@shared/state/recalcStore';

/**
 * Single global "P&L is recalculating" hint shown in the Topbar while a fee change recomputes
 * (broker-fee config change or a manual fee edit). Existing numbers stay visible and refresh when
 * the recompute lands. Themed to match the subtle italic "calculating…" used in the trades table.
 */
export function RecalculatingIndicator({ className = '' }: { className?: string }) {
  const active = useIsRecalculating();
  if (!active) return null;
  return (
    <div
      className={`flex items-center gap-2 text-xs text-text-muted ${className}`}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
      <span className="italic">Recalculating P&amp;L…</span>
    </div>
  );
}
